import { render } from "./ChartsPrice.vue?vue&type=template&id=387a35ac"
import script from "./ChartsPrice.vue?vue&type=script&lang=js"
export * from "./ChartsPrice.vue?vue&type=script&lang=js"

import "./ChartsPrice.vue?vue&type=style&index=0&id=387a35ac&lang=scss"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__